import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKLIGHTPRODUCTDETAILSPAGE_LEGACY_FIELD_ORDER = [
  "text_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskLightProductDetailsPageDescriptor: _generatedKioskLightProductDetailsPageDescriptor,
  kioskLightProductDetailsPageBlocDefinition,
  kioskLightProductDetailsPageDashboardLayout,
  kioskLightProductDetailsPageConfig,
  kioskLightProductDetailsPageResolveConfig,
  kioskLightProductDetailsPageProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Product details page",
    internal_name: "Kiosk - Product details page",
    url: "products/:productId/details",
    defaultParent: [/^Kiosk - Shop page$/i, /^Kiosk - Category page$/i],
    componentType: 'KioskLightProductDetailsPageComponent',
    category: 'page',
    description: "Kiosk - Product details page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.kiosk-light-product-details-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskProductDetailsBlock", "KioskProductsSameCategoryBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-light-product-details-page.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-light-product-details-page.text-color.label",
      }
    }),
    button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-light-product-details-page.button-background-color.label",
      }
    }),
    button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-light-product-details-page.button-text-color.label",
      }
    })
  }),

  () => ({
    omitFields: [
      "background_color",
      "button_background_color",
      "button_text_color",
    ] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-light-product-details-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-light-product-details-page.fieldset.appearance.label",
            fields: ["text_color"],
          },
          {
            legend: "pages.blocks.kiosk-light-product-details-page.fieldset.blocks.label",
            fields: ["body"],
          },
        ],
      },
    ],
  })
);

export function kioskLightProductDetailsPageDescriptor(): IBlockDescriptor;
export function kioskLightProductDetailsPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskLightProductDetailsPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskLightProductDetailsPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskLightProductDetailsPageDescriptor, kioskLightProductDetailsPageProperties, fieldOrder);
}

export {
  kioskLightProductDetailsPageBlocDefinition,
  kioskLightProductDetailsPageDashboardLayout,
  kioskLightProductDetailsPageProperties,
  kioskLightProductDetailsPageConfig,
  kioskLightProductDetailsPageResolveConfig,
};

export type KioskLightProductDetailsPageConfig = typeof kioskLightProductDetailsPageConfig;
